<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" :currentIndex="tabcode"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="w">
        <div class="c-top">
          <tabbar :tabData="tabList" :code="categoryId" :seccode="seccode" :subcode="subcode" @changeSecTab="changeSecTab"></tabbar>
        </div>
      </section>
      <section class="w">
        <div>
          <span class="c-title">{{currentCategory?.categoryName}}</span>
          <span class="english-name">{{currentCategory?.englishName}}</span>
        </div>
      </section>
      <section class="content w">

        <div class="c-left">
          <!-- 内容 -->
          <div class="list">
            <div class="item" v-for="(item, index) in newsList" :key="index" @click="articleDetailClick(item)">
              <!-- <div class="i-left">
                <div class="img-wrap">
                  <img class="img" :src="item.cover" alt="图片" />
                </div>
              </div> -->
              <div class="i-center">
                <h2 class="title">{{ item.articleName }}</h2>
                <!-- <p class="desc" v-html="item.articleContent"></p> -->
              </div>
              <div class="i-right">
                <div class="news-time">
                  {{ item.releaseTime}}
                </div>
              </div>
              <!-- <div class="i-right">
                <div class="i-right-top">
                  {{ item.releaseTime.split("-")[1] }}-{{ item.releaseTime.split("-")[2] }}
                </div>
                <div class="i-right-bottom">
                  {{ item.releaseTime.split("-")[0] }}
                </div>
              </div> -->
            </div>
          </div>
          <!-- 页码 -->
          <div class="m-bot" v-if="newsList.length > 0 && pageCount >= pageSize">
            <el-pagination background layout="prev, pager, next" prev-text="上一页" next-text="下一页" :page-size="pageSize" :total="pageCount" @current-change="changePageClick">
            </el-pagination>
          </div>

          <el-empty description="暂无内容~" v-if="newsList.length == 0"></el-empty>
        </div>

      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/train/header.vue";
import Footer from "@/components/train/footer.vue";
import Breadcrumb from "@/components/common/breadcrumb";
import Tabbar from "@/components/list/tabbar.vue";

import { getArticlePage } from "@/api/home/home.js";
import { getNavItemByCode } from "@/api/common/common.js";
export default {
  name: "Policy",
  components: { pageTop, Header, Footer, Breadcrumb, Tabbar },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: "新闻中心",
      newsList: [],
      article: "",
      pageType: "", //1 文章内容，2 文章列表
      categoryId: "",
      tabcode: "",
      seccode: "",
      subcode: "",
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    };
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return;
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return;
        //侧边栏列表
        this.tabList = res.data[0];

        console.log("this.tabList", this.tabList);

        console.log("this.categoryId", this.categoryId);

        console.log("categoryCode", this.tabList.categoryCode);

        if (this.tabList.categoryCode == this.categoryId) {
          this.currentCategory = this.tabList
        }
        if (this.currentCategory.categoryName == '') {
          let attr = this.tabList.list.filter(p => {
            if (p.categoryCode == this.categoryId) {
              console.log("categoryName", p.categoryName);
              return p;
            }
          })
          if (attr.length) {
            this.currentCategory = attr[0]
          }
        }
      })
      //获取文章列表
      this.getArticlePage();
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == "string") {
        this.$router.push("/" + data);
      }
    },
    //获取文章列表
    getArticlePage(page = 1) {
      getArticlePage({
        page: page,
        limit: this.pageSize,
        categoryCode: this.categoryId,
      }).then((res) => {
        console.log(res.data);
        if (!res.data) return;
        this.newsList = res.data.list;
        this.pageCount = Number(res.data.count);
      });
    },
    //跳转文章详情
    articleDetailClick(item) {
      let url = "/train/articleDetail?categoryId=" + this.currentCategory.categoryCode + "&linkType=" + this.currentCategory.linkType + "&tabcode=" + this.tabcode + '&seccode=' + this.seccode
        + '&id=' + item.articleId

      this.$router.push({
        path: url,
      });

    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page);
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log("item", this.currentCategory);
      console.log("tab", tab);
      let url = "?categoryId=" + item.categoryCode + "&linkType=" + item.linkType + "&tabcode=" + this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab//二级标题
      this.categoryId = item.categoryCode;//当前标题
      this.subcode = item.categoryCode;//三级标题
      this.pageType = item.linkType;
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(item => item.categoryCode == this.categoryId);

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode;
          this.subcode = targetItem.list[0].categoryCode;
          this.categoryId = targetItem.list[0].categoryCode;
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表,6/新闻详情
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl);
        url = "/train/article" + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = "/train/singleImage" + url
      }
      if (item.linkType == 3) {
        this.getArticlePage();
        url = "/train/imageText" + url
      }
      if (item.linkType == 4) {
        url = "/train/textList" + url
      }
      if (item.linkType == 6) {
        url = "/train/articleDetail" + url
      }

      this.$router.push({
        path: url,
      });

    }
  },
  created() {
    this.pageType = this.$route.query?.linkType;
    this.categoryId = this.$route.query?.categoryId;
    this.tabcode = this.$route.query?.tabcode;
    this.seccode = this.$route.query?.seccode;
    this.fetchData();
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb__inner.is-link,
/deep/ .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__separator,
/deep/ .el-breadcrumb__separator:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .c-title {
      font-size: 28px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      color: rgb(153, 153, 153);
      margin-left: 10px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding-bottom: 70px;

        .list {
          display: flex;
          flex-wrap: wrap;

          .item:hover .i-center .title,
          .item:hover .i-center .desc,
          .item:hover .i-right .i-right-top,
          .item:hover .i-right .news-time,
          .item:hover .i-right .i-right-bottom {
            color: #409eff !important;
          }

          .item {
            display: flex;
            align-items: center;
            justify-content: stretch;
            padding: 12px 0;
            cursor: pointer;
            border-bottom: 1px dashed #e4e4e4;

            .i-left {
              margin-right: 20px;
              .img-wrap {
                width: 160px;
                height: 120px;
              }
            }
            .i-center {
              flex: 1;
              width: 1000px;
              .title {
                color: #000000;
                padding: 0;
                margin: 4px 0px;
                font-weight: normal;
                font-size: 16px;
              }

              .desc {
                color: #a3a3a3;
                font-size: 10px;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
            }
            .i-right {
              line-height: 1.35;
              flex-shrink: 0;
              margin-left: 20px;
              font-family: Tahoma;
              width: 100px;
              position: relative;
              text-align: center;
              border-left: 1px solid #e9e9e9;

              .i-right-top {
                font-size: 20px;
              }
              .i-right-bottom {
                font-size: 16px;
                color: #888888;
                margin-top: 6px;
              }
              .news-time {
                margin-left: 20px;
                color: #999;
              }
            }
          }
        }

        .m-bot {
          margin-top: 24px;
          margin-bottom: 24px;

          .el-pagination {
            display: flex;
            justify-content: center;

            /deep/ .btn-prev {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-prev:hover:enabled {
              color: #409eff;
            }

            /deep/ .number {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .more {
              width: 40px;
              height: 40px;
              line-height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next {
              width: 100px;
              height: 40px;
              border: 1px solid #e4e4e4;
              background-color: #fff;
            }

            /deep/ .btn-next:hover:enabled {
              color: #409eff;
            }

            /deep/ .active {
              color: #fff;
              background-color: #409eff;
            }
          }
        }
      }
    }
  }
}
</style>
